import React, { createContext, useState } from 'react';
import {
  ContextPortalID,
  useContextPortal,
} from '../../Router/pages/TourEditPage/hooks/useContextPortal';

import ListingSummaryProps from '../../types/listingSummaryPropsType';

export type AddListingToTourModalContextType = {
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  listing: ListingSummaryProps;
  setListing: React.Dispatch<React.SetStateAction<ListingSummaryProps>>;
};

export const AddListingToTourModalContext =
  createContext<AddListingToTourModalContextType>(null);

export const AddListingToTourModalContextProvider: React.FC = ({
  children,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [listing, setListing] = useState(null);
  const ContextPortal = useContextPortal(
    ContextPortalID.ADD_LISTING_TO_TOUR_CONTEXT,
  );

  return (
    <AddListingToTourModalContext.Provider
      value={{
        modalVisible,
        setModalVisible,
        listing,
        setListing,
      }}
    >
      <ContextPortal />
      {children}
    </AddListingToTourModalContext.Provider>
  );
};

export default AddListingToTourModalContext;
